import { render, staticRenderFns } from "./SpotifyIcon.vue?vue&type=template&id=1caeb7d4"
import script from "./SpotifyIcon.vue?vue&type=script&lang=js"
export * from "./SpotifyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports